import { InjectionToken } from '@angular/core';

export type TenantBranding = {
  siteName: string;
  logoMain: string;
  logoFooter: string;
  loginVisual: string;
};

export const TENANT_BRANDING = new InjectionToken<TenantBranding>(
  'TENANT_BRANDING',
);
